import { render, staticRenderFns } from "./PageTop.vue?vue&type=template&id=5a0b5105&"
import script from "./PageTop.vue?vue&type=script&lang=ts&"
export * from "./PageTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports